let languageCode = 'ar';
module.exports = {
	languageCode,
	endonym: 'العربية',
	displayValue: 'Arabic',
	raadELLPurpose:
		'الإنسان يخزن المعلومات في الكلمات. لهذا ستبني معرفتك عندما تقرأ هذه المقالات. سوف تنمو لغتك ايضًا، و تحسن قدرتك للقراءة، و تتمتع بالقراة كل يوم',
	raadELLPurposeAudio: '/assets/dist/audio/set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'هذه المقالات مليئًآ بالمعلومات. سوف تتعلم أشياء جديدة و مهمة إذا قرأتها. لن تعرف الكثير من الأشياء التي تقرأ عنها، لكن هذا عظيم! القراءة هي واحدة من الطرق لتعلم أشياء جديدة. وعندما تتعلم بعض الأشياء الجديدة، فأصبح أسهل لتعلم المزيد من الأشياء الجديدة! ربما قد تكون تعرف بعض الأشياء في هذه المقالات. هذا<br>رائع أيضا. عندما تقرأ المزيد عن الأشياء التي تعرفها بالفعل، سوف تزيد من معرفتك للغتك. هذا سوف يساعدك على فهم أفكار جديدة و كبيرة.وأخيرا، سوف تصبح قارئ أقوى من خلال قراءة هذه المقالات. سوف تكون قادرا على القراءة لفترات أطول من الزمن .قراءة سعيدة',
	raadELLMindsetAudio: '',
	raadELLChooseOne: '-الرجاء اختيار مقالة واحدة للقراءة الآن',
	raadELLChooseOneAudio: '/assets/dist/audio/aad_instructions_' + languageCode + '.mp3',
	raadELLBOKDirectionsLabel: 'تعليمات',
	raadELLBOKWrite: 'يرجى كتابة ٢ أو ٣ أشياء تعلمتها من المقالة التي تريد تذكرها',
	raadELLBOKWriteAudio: '/assets/dist/audio/bok_instructions_' + languageCode + '.mp3',
	rtl: true
};
